import PermitPage from "./permit";

export default PermitPage;